module.exports = __webpack_public_path__ + "media/exercise-validated.d6a7d083.mp3";